/** Markdown renderer dùng chung cho các panel AI (link mở tab mới, bảng cuộn ngang). */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const aiMarkdownComponents = {
  a: ({ children, href, title }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
    <a href={href} title={title} target="_blank" rel="noreferrer">{children}</a>
  ),
  table: ({ children }: React.TableHTMLAttributes<HTMLTableElement>) => (
    <div role="region" aria-label="Bảng Markdown" tabIndex={0} style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>{children}</table>
    </div>
  ),
  th: ({ children, style }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
    <th style={{
      border: "1px solid var(--ai-border)",
      padding: "6px 8px",
      textAlign: style?.textAlign ?? "left",
    }}>
      {children}
    </th>
  ),
  td: ({ children, style }: React.TdHTMLAttributes<HTMLTableCellElement>) => (
    <td style={{
      border: "1px solid var(--ai-border)",
      padding: "6px 8px",
      textAlign: style?.textAlign ?? "left",
    }}>
      {children}
    </td>
  ),
};

export const AiMarkdown = ({ children }: { children: string }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={aiMarkdownComponents}>
    {children}
  </ReactMarkdown>
);
